"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ramda_1 = require("ramda");
exports.generateTelemetryKey = function (prefix) { return ramda_1.concat(prefix + "."); };
//# sourceMappingURL=generateTelemetryKey.js.map